class ConcreteEventEmitter {
    events = {};
    stateChange = 'stateChange';
    navigation = 'navigation';
    error = 'error';
    progress = 'progress';
    state;
    registerForStateChange(handler) {
        this.register(this.stateChange, handler);
        if (this.state !== undefined) {
            handler(this.state);
        }
    }
    unregisterFromStateChange(handler) {
        this.unregister(this.stateChange, handler);
    }
    registerForNavigation(handler) {
        this.register(this.navigation, handler);
    }
    unregisterFromNavigation(handler) {
        this.unregister(this.navigation, handler);
    }
    registerForErrors(handler) {
        this.register(this.error, handler);
    }
    unregisterFromErrors(handler) {
        this.unregister(this.error, handler);
    }
    emitStateChange(data) {
        this.state = data;
        this.emit(this.stateChange, data);
    }
    emitError(error) {
        this.emit(this.error, error);
    }
    emitNavigation(url) {
        this.emit(this.navigation, url);
    }
    register(event, handler) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(handler);
    }
    unregister(event, handler) {
        if (!this.events[event])
            return;
        this.events[event] = this.events[event].filter((h) => h !== handler);
    }
    emit(event, data) {
        if (!this.events[event])
            return;
        this.events[event].forEach((handler) => handler(data));
    }
}
export const eventEmitter = new ConcreteEventEmitter();
